/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI spec version: 1.0.0
 */

export type GetApiDirectWebstorePayments200DataItemType =
    (typeof GetApiDirectWebstorePayments200DataItemType)[keyof typeof GetApiDirectWebstorePayments200DataItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiDirectWebstorePayments200DataItemType = {
    GIFT_CARD: 'GIFT_CARD',
    DEPOSIT: 'DEPOSIT',
} as const;
